/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  CreateTestUserResponse,
  DeleteTestUsersResponse,
  TestUserLoginResponse,
  VerifyEmailRequest,
  VerifyEmailResponse
} from '../../schemas';

import { customFetchProtected } from '../../../custom-fetcher';

export type verifyEmailResponse200 = {
  data: VerifyEmailResponse
  status: 200
}

export type verifyEmailResponseSuccess = (verifyEmailResponse200) & {
  headers: Headers;
};
;

export type verifyEmailResponse = (verifyEmailResponseSuccess)

export const getVerifyEmailUrl = () => {




  return `/api/v1/dev/verify-email`
}

/**
 * Markiert die E-Mail eines Nutzers programmatisch als verifiziert und setzt sein Passwort in Keycloak. Nur in local/e2e.
 * @summary Verifiziert E-Mail und setzt Passwort eines Nutzers
 */
export const verifyEmail = async (verifyEmailRequest: VerifyEmailRequest, options?: RequestInit): Promise<verifyEmailResponse> => {

  return customFetchProtected<verifyEmailResponse>(getVerifyEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyEmailRequest)
  }
);}


export type createTestUserResponse201 = {
  data: CreateTestUserResponse
  status: 201
}

export type createTestUserResponseSuccess = (createTestUserResponse201) & {
  headers: Headers;
};
;

export type createTestUserResponse = (createTestUserResponseSuccess)

export const getCreateTestUserUrl = () => {




  return `/api/v1/dev/test-user`
}

/**
 * Erstellt einen vollstaendigen Testnutzer mit zufaelliger E-Mail (neue UUID = neue Legitimations-ID). Nur in den Profilen local/e2e verfuegbar.
 * @summary Legt einen Testnutzer (Max Mustermann) an
 */
export const createTestUser = async ( options?: RequestInit): Promise<createTestUserResponse> => {

  return customFetchProtected<createTestUserResponse>(getCreateTestUserUrl(),
  {
    ...options,
    method: 'POST'


  }
);}


export type deleteTestUsersResponse200 = {
  data: DeleteTestUsersResponse
  status: 200
}

export type deleteTestUsersResponseSuccess = (deleteTestUsersResponse200) & {
  headers: Headers;
};
;

export type deleteTestUsersResponse = (deleteTestUsersResponseSuccess)

export const getDeleteTestUsersUrl = () => {




  return `/api/v1/dev/test-user`
}

/**
 * Loescht alle ueber /test-user angelegten Testnutzer. Nur in local/e2e.
 * @summary Loescht alle Testnutzer
 */
export const deleteTestUsers = async ( options?: RequestInit): Promise<deleteTestUsersResponse> => {

  return customFetchProtected<deleteTestUsersResponse>(getDeleteTestUsersUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type createAndLoginOnboardedTestUserResponse201 = {
  data: TestUserLoginResponse
  status: 201
}

export type createAndLoginOnboardedTestUserResponseSuccess = (createAndLoginOnboardedTestUserResponse201) & {
  headers: Headers;
};
;

export type createAndLoginOnboardedTestUserResponse = (createAndLoginOnboardedTestUserResponseSuccess)

export const getCreateAndLoginOnboardedTestUserUrl = () => {




  return `/api/v1/dev/test-user/onboarded/login`
}

/**
 * Wie /test-user/login, durchlaeuft aber zusaetzlich programmatisch das gesamte Onboarding (Vereinsanlage, Vorstands-Mitgliedschaft, Identitaetsstatus=SUCCESS), sodass das Frontend direkt im Haupt-Bereich landet. Nur in local/e2e.
 * @summary Legt einen vollstaendig onboardeten Testnutzer an und liefert Tokens
 */
export const createAndLoginOnboardedTestUser = async ( options?: RequestInit): Promise<createAndLoginOnboardedTestUserResponse> => {

  return customFetchProtected<createAndLoginOnboardedTestUserResponse>(getCreateAndLoginOnboardedTestUserUrl(),
  {
    ...options,
    method: 'POST'


  }
);}


export type createAndLoginTestUserResponse201 = {
  data: TestUserLoginResponse
  status: 201
}

export type createAndLoginTestUserResponseSuccess = (createAndLoginTestUserResponse201) & {
  headers: Headers;
};
;

export type createAndLoginTestUserResponse = (createAndLoginTestUserResponseSuccess)

export const getCreateAndLoginTestUserUrl = () => {




  return `/api/v1/dev/test-user/login`
}

/**
 * Erstellt einen Testnutzer und fuehrt anschliessend einen Password-Grant gegen Keycloak durch. Antwort enthaelt access/id/refresh-Token, damit das Frontend den Login-Bildschirm ueberspringen kann. Nur in local/e2e.
 * @summary Legt einen Testnutzer an und liefert direkt Keycloak-Tokens
 */
export const createAndLoginTestUser = async ( options?: RequestInit): Promise<createAndLoginTestUserResponse> => {

  return customFetchProtected<createAndLoginTestUserResponse>(getCreateAndLoginTestUserUrl(),
  {
    ...options,
    method: 'POST'


  }
);}


export type resetResponse204 = {
  data: void
  status: 204
}

export type resetResponseSuccess = (resetResponse204) & {
  headers: Headers;
};
;

export type resetResponse = (resetResponseSuccess)

export const getResetUrl = () => {




  return `/api/v1/dev/reset`
}

/**
 * Loescht alle Daten in der Anwendung (Keycloak-Nutzer, Vereine, Mitgliedschaften, etc.). Nur in local/e2e.
 * @summary Setzt den Anwendungszustand zurueck
 */
export const reset = async ( options?: RequestInit): Promise<resetResponse> => {

  return customFetchProtected<resetResponse>(getResetUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}


